/**
 * SMA-91: the e-mail typed at sign-up already belongs to an
 * account, and the password typed does not open it (another password, or an
 * account created with Google or Apple). The person is offered to log in
 * instead, with the e-mail filled in, and is never redirected on their own.
 */
export class EmailAlreadyUsedError extends Error {
  constructor(public readonly email: string) {
    super('This e-mail already belongs to an account');
    this.name = 'EmailAlreadyUsedError';
  }
}
